import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import OAuth from "../../oauth";
import Store from "../../store";
var auth = new OAuth();
export default function (_x, _x2, _x3) {
  return _ref.apply(this, arguments);
}
function _ref() {
  _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(to, from, next) {
    var user;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          user = auth.currentUser();
          user.then(function (user) {
            return Store.dispatch('users/setCurrentUser', user);
          }).then(function (result) {
            next();
          }).catch(function (error) {
            // Handle different error types appropriately
            if (error.response && error.response.status === 403) {
              // 403 means user is authenticated but needs verification
              next('/verify');
            } else if (error.response && (error.response.status === 401 || error.response.status === 429)) {
              // 401/429 means user needs to login again
              next('/login');
            } else {
              // For other errors, redirect to login for safety
              next('/login');
            }
          });
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _ref.apply(this, arguments);
}